import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {LocalStorageUtil} from "../utils/local-storage-util";


export const LoginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isAuthenticated = !!LocalStorageUtil.getStorage()?.at;

  return isAuthenticated
    ? router.createUrlTree(['/dashboard'])
    : true;
};
